import React, { useCallback } from 'react';
import { SERVER_TYPE } from '@silverfort-nodelibs/common/utils/consts';
import { SSO_FIELDS } from '../../common/fields';
import * as actions from '../../containers/Security/securityActions';
import Certificate from '../Controls/Certificate/Certificate';
import Label from '../Controls/Label/Label';

import SelectField from '../Controls/SelectField/SelectField';
import SwitchField from '../Controls/SwitchField/SwitchField';
import TextInput from '../Controls/TextInput/TextInput';
import { Icon, Icons, Tooltip } from '@silverfort/sf-components';

const {
    SSO_ENABLED,
    SSO_PROTOCOL,
    SSO_CALLBACK_URL,
    SSO_LOGIN_URL,
    SSO_IDP_ISSUER,
    SSO_BUTTON_TEXT,
    SSO_ROLE_CLAIM_NAME,
    SSO_ENABLED_AUTHN_CONTEXT,
    SSO_AUTHN_CONTEXT,
    SSO_CERTIFICATE
} = SSO_FIELDS;

const SSOConfig = ({ fields, dispatch }) => {
    const ssoEnabled = fields[SSO_ENABLED.ID];
    const protocol = fields[SSO_PROTOCOL.ID];
    const callbackUrl = fields[SSO_CALLBACK_URL.ID];
    const loginUrl = fields[SSO_LOGIN_URL.ID];
    const idpIssuer = fields[SSO_IDP_ISSUER.ID];
    const buttonText = fields[SSO_BUTTON_TEXT.ID];
    const roleClaimName = fields[SSO_ROLE_CLAIM_NAME.ID];
    const enabledAuthnContext = fields[SSO_ENABLED_AUTHN_CONTEXT.ID];
    const authnContext = fields[SSO_AUTHN_CONTEXT.ID];
    const certificate = fields[SSO_CERTIFICATE.ID];

    const dispatchUpdate = useCallback(
        (fieldId, value) => {
            dispatch({
                type: actions.UPDATE_SSO_CONFIG,
                payload: { fieldId, value }
            });
        },
        [dispatch]
    );

    return (
        <>
            {ssoEnabled && <SwitchField field={ssoEnabled} changed={dispatchUpdate} />}
            {protocol && (
                <SelectField field={protocol} changed={dispatchUpdate} options={[{ value: 'saml', label: 'SAML' }]} />
            )}
            {callbackUrl && (
                <TextInput field={callbackUrl} placeholder="https://url/sso/saml/callback" changed={dispatchUpdate} />
            )}
            {loginUrl && (
                <TextInput field={loginUrl} placeholder="https://login.provider/saml2" changed={dispatchUpdate} />
            )}
            {idpIssuer && (
                <TextInput field={idpIssuer} placeholder="https://sts.windows.net/ID/" changed={dispatchUpdate} />
            )}
            {buttonText && <TextInput field={buttonText} placeholder="Sign in with SSO" changed={dispatchUpdate} />}
            {enabledAuthnContext && <SwitchField field={enabledAuthnContext} changed={dispatchUpdate} />}
            {roleClaimName && (
                <div>
                    <div className="flex items-center gap-1">
                        <Label value={roleClaimName.name} />
                        <Tooltip title={roleClaimName.tooltip} className="w-fit">
                            <Icon icon={Icons.Info} className="text-14 text-sf-gray-500 cursor-pointer" />
                        </Tooltip>
                    </div>
                    <TextInput
                        field={{ ...roleClaimName, name: '', tooltip: undefined }}
                        placeholder="silverfortSecurityRole"
                        changed={dispatchUpdate}
                    />
                </div>
            )}
            {authnContext && enabledAuthnContext && enabledAuthnContext.value && (
                <SelectField
                    field={authnContext}
                    changed={dispatchUpdate}
                    multichoice={true}
                    options={authnContext.options}
                />
            )}
            {certificate && (
                <Certificate
                    header={certificate.name}
                    certificate={certificate}
                    serverType={SERVER_TYPE.SSO}
                    generateCSR={false}
                    changed={dispatchUpdate}
                />
            )}
        </>
    );
};

export default React.memo(SSOConfig);
